import React, { useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logoBig from "../img/logo-big.png";
import iconWallet from "../img/iconWallet.png";
import { ethers } from "ethers";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [accounts, setAccount] = useState("");

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  // const provider = new ethers.providers.Web3Provider(window.ethereum);

  const connetMetMask = async () => {
    try {
      const [account] = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      setAccount(account);
    } catch (error) {
      console.log(error);
    }
  };

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img className="logo-big" src={logoBig} alt="Logo" />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
           <li className="nav-item">
              <a
                href="https://boitclub.io/"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                $BOIT
              </a>
            </li>
            <li className="nav-item">
              <a
                href="https://boit.club/"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Boit Club
              </a>
            </li>
            <li className="nav-item">
              {/* <label htmlFor="">balance : <span>{bal}</span></label> <br /> */}
              <button
                className="wallet"
                onClick={() => connetMetMask()} //call phaseOne
              >
                {accounts.length > 0
                  ? `${accounts[0]}${accounts[1]}${accounts[2]}${accounts[3]}${accounts[4]}...${accounts[30]}${accounts[31]}${accounts[32]}`
                  : "Connect Wallet"}
                <span>
                  <img className="icon-wallet" src={iconWallet} />
                </span>
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
